// Which task the Step orb is about: today's open items (in the orb's sector), or —
// when nothing is on the day — the resolver's steps (KYRS / TKNE / ORACLE).
import type { NowStep } from '../useCurrentStep';
import type { Sector } from '../../domain/olmps';
import { itemsForSector } from './data';
import type { OrbItem } from './types';

export function ghostOf(s: NowStep, dayKey: string): OrbItem {
  const kyrsTask = s.source === 'kyrs' ? s.toolOpts?.initialTaskId ?? null : null;
  return {
    key: `step:${s.key}`,
    source: 'step',
    rowId: null,
    itemId: null,
    taskId: kyrsTask,
    title: s.title,
    date: dayKey,
    hasTime: false,
    start: null,
    minutes: 30,
    completed: false,
    missed: '',
    sector: s.sector,
    designId: s.designId ?? null,
    sort: 2000,
    scheduledRaw: null,
    stepSource: s.source,
    stageKey: s.source === 'tkne' ? s.key.split(':')[2] : undefined,
  };
}

export function buildPool(items: OrbItem[], sector: Sector | null, steps: NowStep[], dayKey: string): OrbItem[] {
  const day = itemsForSector(items, sector).filter((i) => i.date === dayKey && !i.completed);
  if (day.length) return day;
  return steps.filter((s) => !sector || s.sector === sector).map((s) => ghostOf(s, dayKey));
}

/** The resolver's current step first, then whatever is in its time window, then the first. */
export function defaultStep(pool: OrbItem[], steps: NowStep[], now: Date): OrbItem | null {
  const first = steps[0];
  if (first) {
    const hit = pool.find((i) => (i.rowId && first.key.startsWith(`metis:${i.rowId}:`)) || (i.taskId && first.key === `kyrs:${i.taskId}`) || i.key === `step:${first.key}`);
    if (hit) return hit;
  }
  const live = pool.find((i) => i.start && i.start <= now && now < new Date(i.start.getTime() + i.minutes * 60000));
  return live ?? pool[0] ?? null;
}
